/**
 * Appoint & Withdraw Director (B32111) chatflow — appointDirectorFlow 재사용.
 *   steps/handleEvent(인물 역할별 officer-list · 주소 directInput → address-input) 그대로 사용.
 *   선임(f45) = defaultRole CONTACT(글로벌 컨택트), 사임(res) = defaultRole DIRECTOR(엔티티 이사).
 *   패널은 주소 fieldGroup 을 directorAddress/directorAlternateAddress 로 emit 해 이 플로우 핸들러에 맞춘다.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import { appointDirectorFlow } from './appointDirectorFlow';

export const appointWithdrawDirectorFlow: ChatFlow = {
  ...appointDirectorFlow,
  id: 'sg-appoint-withdraw-director',
  taskCodeMatch: ['B32111'],
  // "appoint/withdraw" 슬래시/기호 변형까지 — withdraw 단독('withdraw director')은 안 가로챈다(내 flow 가 먼저 등록돼 우선).
  categoryMatch: ['appoint/withdraw director', 'appoint / withdraw director', 'appoint/withdraw', 'appoint & withdraw director', 'appoint and withdraw director', 'appoint withdraw director'],

  getInitialMessages(preSet): ConversationMessage[] {
    const docCount = preSet.documents.length;
    return [
      {
        role: 'ai',
        content:
          `You selected **${preSet.task.TASK_NAME || 'Appoint & Withdraw Director'}**.\n\n` +
          (docCount > 0 ? `This preset prepares ${docCount} template(s): a Directors' Resolution, a Form 45 per appointed director, and a Resignation Letter per resigning director.\n\n` : '') +
          `In **Stage 2 (Appoint)** the ✨ looks up a **contact**; in **Stage 3 (Withdraw)** it looks up the entity's **directors**.\n\n` +
          `First, enter a **Task Title**, then select the **Singapore company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
